const update_currency = async (inputs) => {
    const rowId = inputs.Id;
    const response = await axios.patch(
        `/currencyResources/${rowId}`,
        inputs,
    );
    return response;
}  

const delete_currency = async (id) => {
    const response = await axios.delete(`/currencyResources/${id}`);
    return response;
}

const get_data_currency = async (id) => {
    try {
        const response = await axios.get(`/currencyResources/${id}`);                 
        const res = response.data;
        if (res) { 
            let obj = {
                Id: res.Id,
                Code : res.Code,
                Title : res.Title,
                simbolo : res.simbolo, 
            }
            return obj;         
        }
    } catch (error) {
        console.error('Error fetching currency:', error);
        return false;
    } 
}



export { update_currency, get_data_currency, delete_currency };